// extracted by mini-css-extract-plugin
export var falconContainer = "_vw-2";
export var offerCenter = "_vw-0";
export var roktContainer = "_vw-1";